/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CommunityInputs */

const en_nav_community = /** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const es_nav_community = /** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunidad`)
};

const fr_nav_community = /** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communauté`)
};

const de_nav_community = /** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community`)
};

const id_nav_community = /** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komunitas`)
};

/** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */
const ja_nav_community = en_nav_community;

/** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */
const zh_nav_community = en_nav_community;

/** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */
const ar_nav_community = en_nav_community;

/** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */
const it_nav_community = en_nav_community;

/** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */
const ru_nav_community = en_nav_community;

/** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */
const pt_nav_community = en_nav_community;

/** @type {(inputs: Nav_CommunityInputs) => LocalizedString} */
const ko_nav_community = en_nav_community;

/**
* | output |
* | --- |
* | "Community" |
*
* @param {Nav_CommunityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_community = /** @type {((inputs?: Nav_CommunityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CommunityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_community(inputs)
	if (locale === "es") return es_nav_community(inputs)
	if (locale === "fr") return fr_nav_community(inputs)
	if (locale === "de") return de_nav_community(inputs)
	if (locale === "ja") return ja_nav_community(inputs)
	if (locale === "zh") return zh_nav_community(inputs)
	if (locale === "ar") return ar_nav_community(inputs)
	if (locale === "id") return id_nav_community(inputs)
	if (locale === "it") return it_nav_community(inputs)
	if (locale === "ru") return ru_nav_community(inputs)
	if (locale === "pt") return pt_nav_community(inputs)
	return ko_nav_community(inputs)
});